import { Communication } from '../redux/ducks'
import { UIState }       from '../types'

const communicationToUiState = (communication: Communication) => {
  let ui

  if (communication.success) {
    ui = UIState.loaded
  } else if (communication.error) {
    ui = UIState.failed
  } else {
    ui = UIState.loading
  }

  return ui
}

export default communicationToUiState



// WEBPACK FOOTER //
// ./src/project-utils/communication-to-ui-state.ts